import React, { Component } from "react";
import { bool } from "prop-types";

class FinalStep extends Component {
  static propTypes = {
    isEachSecretKeySubmitted: bool.isRequired,
    isBankAccountCreated: bool.isRequired,
  };

  static defaultProps = {
    isBankAccountCreated: false,
  };

  render() {
    const { isEachSecretKeySubmitted, isBankAccountCreated } = this.props;

    return (
      <div style={{ marginBottom: 10 }}>
        <h2>
          Completed!{" "}
          <i
            className="fa fa-check-circle"
            style={{ color: "#4dbd74", marginRight: 5 }}
            aria-hidden="true"
          />
          {getHeaderText(isEachSecretKeySubmitted, isBankAccountCreated)}
        </h2>
      </div>
    );
  }
}

function getHeaderText(isEachSecretKeySubmitted, isBankAccountCreated) {
  if (!isEachSecretKeySubmitted) return null;

  if (!isBankAccountCreated)
    return <span>The bank account is in the process of reinstallation</span>;

  return <span>The bank account has been reinstalled successfully</span>;
}

export default FinalStep;
